import {mapActions, mapGetters, mapState} from 'vuex';
import {TotalPeriods, Weekdays} from '../../constants';
import moment from 'moment';

export default {
    computed: {
        ...mapState('auth', ['userId', 'name']),
        ...mapState('unavailable', [ 'vacancies']),
        ...mapState('setting', ['rooms', 'sys', 'weekRanges']),
        ...mapGetters('setting', ['schoolYear', 'semester']),

        weekdays() {
            return [...Array(7).keys()].map(w => ({
                key: w + 1,
                label: Weekdays[w + 1]
            }));
        },

        periodOpts() {
            return [...Array(TotalPeriods).keys()].map(p => ({
                key: p + 1,
                label: `第${p + 1}節`,
                value: p + 1
            }))
        },

        pickerDisabled() {
            const {form} = this;
            return !form.periods || form.periods.length === 0 || form.periods.some(p => !p);
        },

        datePickerOptions(){
            return ({
                disabledDate(date) {
                    return moment().isAfter(date, 'd');
                },
                firstDayOfWeek: 1
            });
        }
    },
    methods:{
        ...mapActions('unavailable', {
            getVacancyRoomsInRange: 'getVacancyRoomsInRangeAction',
            getVacancyRoomsInRangeExcept: 'getVacancyRoomsInRangeExceptAction',
        }),
        ...mapActions('setting', {
            getWeekRanges: 'getWeekRangesAction'
        }),
    },

    props: {
        loading: {
            type: Boolean,
            default: false
        }
    },


}
